import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .priceDifference {
    width: 100%;
    text-align: left;
    color: ${colors.white};
    font-size: 14px;
    font-weight: 600;
    margin: 16px 0 0 0;
  }

  .warning {
    font-size: 14px;
    font-weight: 600;
    color: ${colors.yellow};
    margin: 16px 0 0 0;
  }
`;

export const ChangeDetailsContainer = styled.table`
  width: 100%;

  thead {
    background-color: ${colors.black2};
    th {
      font-size: 14px;
      font-weight: 600;
      color: ${colors.white};
      padding: 8px 16px;
    }
  }

  tbody {
    background-color: ${colors.black1};
    tr {
      padding: 4px;

      .description {
        font-size: 14px;
        font-weight: 600;
        color: ${colors.silver};
        padding: 8px 16px;
      }

      .currentRoom, .selectedRoom {
        font-size: 14px;
        font-weight: 600;
        color: ${colors.white};
        padding: 8px 16px;
      }
    }
  }
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 24px 0 0 0;

  .buttonContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .back {
      font-size: 18px;
      font-weight: 700;
      margin-right: 30px;
      color: ${colors.lightBlue};
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export const TravelInputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 24px 0 0 0;
  column-gap: 10px;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    row-gap: 25px;
  }

  .checkIn, .checkOut {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 10px;
    
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }

  span {
    display: block;
    margin-bottom: 7px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1px;
    color: ${colors.silver};
    white-space: nowrap;

    @media only screen and (max-width: 1200px) {
      font-size: 11px;
    }
  }

  .datePickerContainer {
    width: 55%;
  }
  
  .timePickerContainer {
    width: 45%;
  }
`;
